import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUserAdmin } from "../../admin/UserContext";
import { Container, Grid, Card, Typography, Box, CircularProgress, CardActionArea } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';



export const HomeAdmintrador = () => {
    const [producto, setProducto] = useState({});
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [cantidad, setCantidad] = useState([]);
    const [ultimaFechaCorreo, setUltimaFechaCorreo] = useState(null);
    const [categoria, setCategoria] = useState([]);
    const { Token } = useUserAdmin();
    const backendURL = process.env.REACT_APP_BACKEND_URL;


    useEffect(() => {
        const fetchAll = async () => {
            setLoading(true);
            try {
                const [slidersRes, categoriasRes, cantidadRes, vistaRes] = await Promise.all([
                    axios.get(`${backendURL}/api/producto/categoria`, {
                        headers: { Authorization: `Bearer ${Token}` },
                    }),
                    axios.get(`${backendURL}/api/all/producto/home`, {
                        headers: { Authorization: `Bearer ${Token}` },
                    }),
                    axios.get(`${backendURL}/api/reporte/producto`, {
                        headers: { Authorization: `Bearer ${Token}` },
                    }),
                    axios.get(`${backendURL}/api/reporte/correo`, {
                        headers: { Authorization: `Bearer ${Token}` },
                    }),
                ]);

                setProducto(slidersRes.data.data);
                setCategoria(categoriasRes.data.data);
                setCantidad(cantidadRes.data);

                const fechas = vistaRes.data.data
                    .filter(item => item.enviado_en)
                    .map(item => new Date(item.enviado_en));

                const ultimaFecha = fechas.length ? new Date(Math.max(...fechas)) : null;
                setUltimaFechaCorreo(ultimaFecha);
            } catch (error) {
                console.error("Error al obtener datos del administrador:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [Token, backendURL]);



    const formatearFecha = (fecha) => {
        if (!fecha) return "Sin datos";
        return fecha.toLocaleDateString("es-CL", {
            day: "2-digit",
            month: "long",
            year: "numeric"
        });
    };

    const getCategoriaTitulo = (id) => {
        const cat = categoria.find((c) => c.id === parseInt(id));
        return cat ? `${cat.titulo}${cat.titulo1 ? " " + cat.titulo1 : ""}` : `Categoría ${id}`;
    };

    const categoriasConTotales = Object.entries(producto).map(([categoriaId, items]) => {
        const sumaCantidad = items.reduce((sum, prod) => {
            const cantidadNumerica = parseInt(prod.cantidad);
            return sum + (isNaN(cantidadNumerica) ? 0 : cantidadNumerica);
        }, 0);

        const color = (items[0] && items[0].color) ? items[0].color : "#1976d2";

        return {
            id_categoria: parseInt(categoriaId),
            totalProductos: items.length,
            sumaCantidad,
            color,
        };
    });


    const mejorProducto = [...cantidad]
        .filter((p) => p.cantidad !== null)
        .sort((a, b) => b.cantidad - a.cantidad)[0];

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                    <CircularProgress size={80} thickness={6} />
                </Box>
            </div>
        );
    }
    return (
        <Container maxWidth="xl" sx={{ mt: 4 }}>

            <Grid container >
                <Grid size={{ sm: 12, md: 8 }}>
                    <Grid container spacing={3}>

                        {categoriasConTotales.map((cat, index) => (
                            <Grid size={{ sx: 12, sm: 6, md: 4 }} key={index}>
                                <Card sx={{ width: "90%", p: 2, textAlign: "center", borderRadius: 3, boxShadow: 4, background: "#ffff" }}>
                                    <Typography variant="h6" gutterBottom sx={{ color: "#1A425B", fontWeight: '600', fontSize: '1rem', textTransform: 'uppercase' }}>
                                        {getCategoriaTitulo(cat.id_categoria)}
                                    </Typography>

                                    <Box sx={{ position: "relative", display: "inline-flex", mt: 2, mb: 2 }}>
                                        <CircularProgress
                                            variant="determinate"
                                            value={100}
                                            size={120}
                                            thickness={5}
                                            sx={{ color: "#e0e0e0" }}
                                        />
                                        <CircularProgress
                                            variant="determinate"
                                            value={100}
                                            size={120}
                                            thickness={5}
                                            sx={{ position: "absolute", left: 0, color: cat.color }}
                                        />
                                        <Box
                                            sx={{
                                                top: 0,
                                                left: 0,
                                                bottom: 0,
                                                right: 0,
                                                position: "absolute",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Typography variant="h4" component="div" color="primary" sx={{ color: "#1A425B", fontWeight: '600', fontSize: '1.5rem' }}>
                                                {cat.totalProductos}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary" sx={{ color: "#1A425B", fontWeight: '500', fontSize: '1rem' }}>
                                                productos
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                        <Grid size={{ xs: 12, ms: 6, md: 4 }}>
                            <Card
                                sx={{
                                    width: "90%",
                                    height: '220px',
                                    p: 5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    textAlign: "center",
                                    borderRadius: 3,
                                    boxShadow: 4,
                                    background: "#ffff",
                                }}
                            >
                                {/* Ícono grande */}
                                <EmailOutlinedIcon sx={{ fontSize: 50, color: "#00A69E", mb: 1 }} />

                                {/* Título */}
                                <Typography variant="h6" sx={{ color: "#00A69E" }}>
                                    Correo enviado
                                </Typography>

                                {/* Fecha */}
                                <Typography variant="body1" sx={{ mt: 2, color: "#1A425B", fontWeight: '500', fontSize: '1rem' }}>
                                    {formatearFecha(ultimaFechaCorreo)}
                                </Typography>
                            </Card>
                        </Grid>
                        <Grid size={{ xs: 12, ms: 6, md: 4 }}>
                            <CardActionArea onClick={() => navigate("/administrador/productos/pagina/Inicio")}>
                                <Card sx={cardStyle}>
                                    <Inventory2OutlinedIcon sx={{ fontSize: 50, color: "#00A69E", mb: 1 }} />
                                    <Typography variant="h6" sx={{ color: "#00A69E" }}>
                                        Ver productos
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 1, color: "#1A425B", fontWeight: '500', fontSize: '1rem' }}>
                                        Gestiona y revisa todos los productos registrados.
                                    </Typography>
                                </Card>
                            </CardActionArea>
                        </Grid>
                        <Grid size={{ xs: 12, ms: 6, md: 4 }}>
                            <CardActionArea onClick={() => navigate("/administrador/Producto/pagina/Inicio")}>
                                <Card sx={cardStyle}>
                                    <CategoryOutlinedIcon sx={{ fontSize: 50, color: "#00A69E", mb: 1 }} />
                                    <Typography variant="h6" sx={{ color: "#00A69E" }}>
                                        Ver categorías
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 1, color: "#1A425B", fontWeight: '500', fontSize: '1rem' }}>
                                        Administra las categorías disponibles.
                                    </Typography>
                                </Card>
                            </CardActionArea>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ sm: 12, md: 4 }}>
                    {mejorProducto && (
                        <Card
                            sx={{
                                p: 3,
                                borderRadius: 3,
                                boxShadow: 4,
                                backgroundColor: "#fff",
                                textAlign: "center",
                                borderLeft: `6px solid ${mejorProducto.color || "#FFD700"}`,
                            }}
                        >
                            <StarIcon sx={{ fontSize: 40, color: "#FFD700" }} />
                            <Typography variant="h6" sx={{ mt: 2, mb: 2, color: "#1A425B", fontWeight: '500', fontSize: '1.3rem' }}>
                                Mejor Producto
                            </Typography>
                            {mejorProducto.imagen_producto && (
                                <img
                                    src={`${backendURL}/${mejorProducto.imagen_producto}`}
                                    alt="Fondo"
                                    style={{ width: "150px", height: "auto", borderRadius: 4 }}
                                />
                            )}
                            <Typography variant="body1" sx={{ mt: 3, mb: 2, color: "#1A425B", fontWeight: '700', fontSize: '1.5rem' }}>
                                {mejorProducto.titulo_maquina || ""}  {mejorProducto.nombre_maquina || ""}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#1A425B", fontWeight: '600', fontSize: '1rem' }}>
                                Categoría: {getCategoriaTitulo(mejorProducto.categoria_id)}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 1, color: "#1A425B", fontWeight: '500', fontSize: '1.2rem' }}>
                                visto: {mejorProducto.cantidad}
                            </Typography>
                        </Card>
                    )}
                </Grid>

            </Grid>

        </Container>
    )
}

const cardStyle = {
    width: "90%",
    height: '220px',
    p: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: "center",
    borderRadius: 3,
    boxShadow: 4,
    background: "#fff",
    transition: "transform 0.2s",
    "&:hover": {
        transform: "scale(1.03)",
        boxShadow: 6,
    },
};